<template>
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <h4 class="mb-0 font-size-18">Laporan Laba Rugi</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboard</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">Laporan Laba Rugi</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <loading
              :active.sync="isLoading"
              :is-full-page="false"
              :height="45"
              :width="45"
              color="#398BD7"
            ></loading>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Invoice</th>
                  <th scope="col">Tanggal</th>
                  <th scope="col">Subtotal Penjualan</th>
                  <th scope="col">Subtotal Pembelian</th>
                  <th scope="col">Subtotal 3rd Party</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item[alias_table+'_code'] }}</td>
                  <td>{{ item[alias_table+'_hours_start'] }}</td>
                  <td>Rp {{ $root.numberWithCommas(item[alias_table+'_actual_price']) }}</td>
                  <td>Rp {{ $root.numberWithCommas(item['sub_total_pembelian']) }}</td>
                  <td>Rp {{ $root.numberWithCommas(item['sub_total_thirdparty']) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      module: "Servis Transaksi",
      table_module: "services_transaction",
      alias_table: "srv_t",
      fields: {},
      data: [],
      orderBy: "created_at",
      sort: "desc",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      this.axios.post("/services_transaction/laba").then((response) => {
        this.data = response.data.data;
      });
    },    
  },
};
</script>